import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listExposeAPI: [],
  detailsExposeAPI: {},
  showModalSetting: false,
  objectFields: {},
  showModalPayload: false,
  detailsPayload: {},
  allFields: {},
};

const slice = createSlice({
  name: "exposeAPIInteraction",
  initialState,
  reducers: {
    loadListExposeAPII(state, action) {},
    loadListExposeAPIIResult(state, action) {
      state.listExposeAPI = action.payload;
    },
    createExposeAPII(state, action) {},
    deleteExposeAPII(state, action) {},
    updateExposeAPII(state, action) {},
    getDetailsExposeAPII(state, action) {},
    getDetailsExposeAPIIResult(state, action) {
      state.detailsExposeAPI = action.payload;
    },
    getDetailsPayload(state, action) {},
    getDetailsPayloadResult(state, action) {
      state.detailsPayload = action.payload;
    },
    setShowModalSetting(state, aciton) {
      state.showModalSetting = aciton.payload;
    },
    setShowModalPayload(state, aciton) {
      state.showModalPayload = aciton.payload;
    },
    loadObjectFields(state, action) {},
    loadObjectFieldsResult(state, action) {
      state.objectFields = {
        ...state.objectFields,
        ...action.payload,
      };
    },
    loadAllFieldsResult(state, action) {
      state.allFields = {
        ...state.allFields,
        ...action.payload,
      };
    },
  },
});

export default slice.reducer;

export const {
  loadListExposeAPII,
  loadListExposeAPIIResult,
  createExposeAPII,
  deleteExposeAPII,
  updateExposeAPII,
  getDetailsExposeAPII,
  getDetailsExposeAPIIResult,
  getDetailsPayload,
  getDetailsPayloadResult,
  setShowModalSetting,
  setShowModalPayload,
  loadObjectFields,
  loadObjectFieldsResult,
  loadAllFieldsResult,
} = slice.actions;
